import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Inbox } from "lucide-react";
import SimpleTable from "../../../../SimpleTable";
import { useColumns } from "./hooks/useColumns";
import { useQualificationQuery } from "./hooks/useQualificationQuery";
import { renderSettingsResourceLabel } from "../../../../../utils/helpers/settings";
import { cn } from "../../../../../lib/utils";

const tabs = ["skills", "licenses", "certifications"] as const;
type Tab = typeof tabs[number];

function NoData() {
    const { t } = useTranslation();
    return (
        <div className="tw-flex tw-flex-col tw-text-neutral-500 tw-justify-center tw-items-center tw-py-8 tw-border tw-border-dashed tw-rounded-lg">
            <Inbox />
            <p className="tw-text-muted-foreground">{t("no-data")}</p>
        </div>
    );
}

function Qualifications({ user }: any) {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState<Tab>("skills");
    const columns = useColumns();
    const { skillQuery, licenseQuery, certificationsQuery } = useQualificationQuery(user);

    const skills = skillQuery.data ?? [];
    const licenses = licenseQuery.data ?? [];
    const certifications = certificationsQuery.data ?? [];

    return (
        <div className="tw-border tw-rounded-xl tw-overflow-hidden tw-flex tw-flex-col">
            <div className="tw-flex tw-border-b">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        type="button"
                        onClick={() => setActiveTab(tab)}
                        className={cn(
                            "tw-px-5 tw-py-3 tw-text-sm tw-font-medium tw-border-b-2 tw--mb-px tw-transition-colors tw-cursor-pointer",
                            activeTab === tab
                                ? "tw-border-primary tw-text-foreground"
                                : "tw-border-transparent tw-text-muted-foreground hover:tw-text-foreground hover:tw-border-muted-foreground"
                        )}
                    >
                        {t(tab)}
                    </button>
                ))}
            </div>

            <div className="tw-p-5 tw-flex tw-flex-col tw-gap-3">
                {activeTab === "skills" && (
                    skills?.length > 0 ? (
                        <div className="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
                            {skills.map((skill: any) => (
                                <span
                                    key={skill.id}
                                    className="tw-bg-primary/10 tw-text-primary tw-text-xs tw-font-medium tw-px-3 tw-py-1 tw-rounded-md"
                                >
                                    {renderSettingsResourceLabel(skill)}
                                </span>
                            ))}
                        </div>
                    ) : <NoData />
                )}

                {activeTab === "licenses" && (
                    licenses?.length > 0 ? (
                        <SimpleTable
                            data={licenses}
                            columns={columns}
                            footer={false}
                            enableRowSelection={false}
                            loading={undefined}
                            getRowProps={undefined}
                        />
                    ) : <NoData />
                )}

                {activeTab === "certifications" && (
                    certifications?.length > 0 ? (
                        <SimpleTable
                            data={certifications}
                            columns={columns}
                            footer={false}
                            enableRowSelection={false}
                            loading={undefined}
                            getRowProps={undefined}
                        />
                    ) : <NoData />
                )}
            </div>
        </div>
    )
}

export default Qualifications;
